import './style.scss';
import { CreateTeamBody } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket/types';
import { useParams } from 'react-router-dom';
import { useGetTeamByKey } from '@trufla-technology/trufla-trudomain/dist/lib/truMarket';
import { TeamDetails } from './TeamDetails';
interface IParamTypes {
  teamKey: string;
}
export const EditTeamDetails = () => {
  const { teamKey } = useParams<IParamTypes>();

  const { data } = useGetTeamByKey(teamKey, {
    param: {
      select: ['key', 'description', 'name'],
    },
  });

  return (
    <div className="">
      <TeamDetails mode="edit" initialData={(data as CreateTeamBody) || ''} />
    </div>
  );
};
